import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../state';
import { fetchAlarmSummaries, findSummariesByRange } from '../../state/entities';

import { Box, CircularProgress, makeStyles, Typography } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import { Link } from 'react-router-dom';

import { warningColor, primaryGreen } from 'src/data/colors';

import { PathBuilder } from 'src/routing';
import { useRequest } from 'src/helpers/hooks';
import { Lifecycle } from 'src/state/request';

const useStyles = makeStyles((theme) => ({
  alarms: {
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${warningColor}`,
    display: 'flex',
    padding: 8,
    borderRadius: 4,
    textDecoration: 'none',
    color: 'black',
  },
  icon: {
    color: warningColor,
    display: 'block',
    margin: 0,
    marginLeft: 0,
  },
  quantity: {
    display: 'block',
    marginLeft: 16,
  },
}));
const LOOKBACK = 1000 * 60 * 60 * 24 * 7;

interface ActiveAlarmsProps {
  siteId: number;
  quantity?: number;
}

const ActiveAlarms = ({ siteId, quantity }: ActiveAlarmsProps) => {
  const action = fetchAlarmSummaries.request(siteId, LOOKBACK);
  const [, requestStatus] = useRequest(action, !quantity);
  const rootState = useSelector((state: RootState) => state);

  const activeAlarms = useMemo(
    () => findSummariesByRange(rootState, siteId, LOOKBACK, true),
    [siteId, rootState]
  );

  const classes = useStyles();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Link to={PathBuilder.ALARMS_DEFAULT(siteId)} className={classes.alarms} onClick={handleClick}>
      <WarningIcon className={classes.icon} />
      <Box className={classes.quantity}>
        {quantity ? (
          <Typography>{quantity}</Typography>
        ) : requestStatus !== Lifecycle.COMPLETED ? (
          <CircularProgress size={20} style={{ color: primaryGreen }} />
        ) : (
          <Typography>{activeAlarms.length}</Typography>
        )}
      </Box>
    </Link>
  );
};

export default ActiveAlarms;
